import { ReactNode } from "react";

interface IconWithTooltipProps {
  icon: ReactNode;
  tooltip: string;
  handler?: (
    e:
      | React.MouseEvent<HTMLButtonElement>
      | React.KeyboardEvent<HTMLButtonElement>,
  ) => void;
  className?: string;
  disabled?: boolean;
  tooltipPosition?: "top" | "bottom" | "left" | "right";
  type?: "button" | "submit" | "reset";
}

export const IconWithTooltip = ({
  icon,
  tooltip,
  handler,
  className = "btn btn-ghost btn-sm rounded-lg",
  disabled = false,
  tooltipPosition = "top",
  type = "button",
}: IconWithTooltipProps) => {
  const isClickable = !!handler && !disabled;
  const shouldRenderButton =
    isClickable || type === "submit" || type === "reset";

  const handleOnClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    if (!isClickable) {
      return;
    }
    handler(e);
  };
  const handleKeyDown = (e: React.KeyboardEvent<HTMLButtonElement>) => {
    if (e.key === "Enter" || e.key === " ") {
      e.stopPropagation();
      if (!isClickable) {
        return;
      }
      handler(e);
    }
  };

  return (
    <div
      className={`tooltip tooltip-${tooltipPosition} flex items-center`}
      data-tip={tooltip}
    >
      {shouldRenderButton ? (
        <button
          type={type}
          className={className}
          onClick={handleOnClick}
          onKeyDown={handleKeyDown}
          disabled={disabled}
        >
          {icon}
        </button>
      ) : (
        <span className={`${className} cursor-default border-0 bg-transparent`}>
          {icon}
        </span>
      )}
    </div>
  );
};
